import React from 'react';
import { ScrollView, View } from 'react-native';
import Typography from 'src/components/Text/Text';
import NavigationButtons from 'src/features/application/components/NavigationButtons';
import SwitchSection from 'src/features/application/components/SwitchSection';
import { styles } from './InsuranceScreen.styles';
import { useInsurance } from '../hooks/useInsurance';
import { getInsuranceSections } from './insuranceSectionsConfig';
import { URLS } from 'src/constants/urls';
import { useLinkTo } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from 'src/slices/UiSlice';
import { TABS_INDEX } from 'src/constants/tabs';
import Toast from 'src/components/Toast/Toast';
import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';
import { RootState } from 'src/store/store';

const InsuranceScreen: React.FC = () => {
  const insurance = useInsurance();
  const sections = getInsuranceSections(insurance);
  const linkTo = useLinkTo();
  const dispatch = useDispatch();

  const accountType = useSelector((state: RootState) => state.UI.accountType);

  const handleBack = () => {
    trackGTMEvent(
      'lob-page-left',
      {
        userEvent: 'User clicked Back and navigated to the Commodities screen',
      },
      accountType,
    );

    linkTo(URLS.FREIGHT);
    dispatch(setActiveTab({ activeTab: TABS_INDEX.FREIGHT }));
  };

  const handleNext = () => {
    trackGTMEvent(
      'lobs-given',
      {
        userEvent: 'User clicked Next to confirm selected LOB',
      },
      accountType,
    );

    insurance.handleSaveOrUpdate();
  };

  return (
    <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>
      <Typography variant="h2">Select your insurance coverages</Typography>

      {/* Dynamically render sections */}
      {sections.map((section, index) => (
        <View style={styles.switchSectionsCard} key={index}>
          <SwitchSection
            parentTestID={`select-insurance-sectin-${index + 1}`}
            label={section.label}
            value={section.value}
            onChange={(value) => {
              // Track LOBs Selected event when LOB option is selected
              trackGTMEvent(
                'lobs-selected',
                {
                  userEvent: `User selected LOB`,
                },
                accountType,
              );
              section.onChange(value);
            }}
            buttons={section.buttons}
            childrenRenderCondition={section.renderCondition}>
            {section.ChildComponent && <section.ChildComponent {...section.childProps} />}
          </SwitchSection>
        </View>
      ))}
      {insurance.insuranceSaveErrorToast && (
        <Toast
          text={'An error occurred while saving your coverages. Please try again.'}
          type={'error'}
          animate={true}
        />
      )}
      <NavigationButtons
        testID={'select-insurance-section-btn'}
        onBack={handleBack}
        onNext={handleNext}
        isNextDisabled={
          !insurance.autoLiability.value ||
          !insurance.physicalDamage.value ||
          !insurance.motorTruckCargo.value ||
          !insurance.generalLiability.value ||
          !insurance.nonTruckingLiability.value
        }
      />
    </ScrollView>
  );
};

export default InsuranceScreen;
